import React from "react";
import { RadioButton } from "primereact/radiobutton";
import ShareholderInformationForm from "./ShareholderInformationForm";

const ShareholderInformationWrapper = ({
  setBtnToggle,
  formDetails,
  setFormDetails,
  regData,
  setRegData,
  isEditing,
  isNewShareholder,
  shareholderType,
  setShareholderType,
  resetRegData,
}) => {
  const statusOptions =
    shareholderType === "Individual"
      ? [
          {
            name: "Active",
            code: "Active",
            colorClass: "active-circle-fill",
          },
          {
            name: "Inactive",
            code: "Inactive",
            colorClass: "inactive-circle-fill",
          },
          {
            name: "Deceased",
            code: "Deceased",
            colorClass: "deceased-circle-fill",
          },
        ]
      : [
          {
            name: "Active",
            code: "Active",
            colorClass: "active-circle-fill",
          },
          {
            name: "Inactive",
            code: "Inactive",
            colorClass: "inactive-circle-fill",
          },
        ];

  const legalStructureOptions = [
    {
      name: "C Corp",
      code: "C Corp",
    },
    {
      name: "S Corp",
      code: "S Corp",
    },
    {
      name: "LLC",
      code: "LLC",
    },
  ];

  const resolveValue = (value, options) =>
    value && typeof value === "object"
      ? value
      : options?.find((option) => option.code === value);

  const handleRadioBtn = (e) => {
    resetRegData();
    setShareholderType(e.value);
  };

  return (
    <>
      {isNewShareholder && (
        <div className="formgrid grid">
          <div className="field col-12">
            <p className="add-new-entity-heading mb-2">
              Shareholder Information
            </p>
            <p className="input-label m-0">
              Enter all the details for this appointment
            </p>
          </div>
        </div>
      )}

      <div className="formgrid grid">
        {isNewShareholder && (
          <>
            <div className="field col-12">
              <p className="appointment-para">
                Select the type of shareholder you want to register
              </p>
            </div>
            <div className="field col-6">
              <div className="appointment-card h-full">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="shareholder1"
                    name="type"
                    value="Individual"
                    onChange={handleRadioBtn}
                    checked={shareholderType === "Individual"}
                  />
                  <label htmlFor="ingredient1" className="ml-3">
                    <div className="flex flex-column justify-content-start">
                      <p className="appointment-para">Individual</p>
                      <p className="appointment-radio-para">
                        A natural person who owns shares in the company.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div className="field col-6">
              <div className="appointment-card h-full">
                <div className="flex align-items-center">
                  <RadioButton
                    inputId="shareholder2"
                    name="type"
                    value="Corporate"
                    onChange={handleRadioBtn}
                    checked={shareholderType === "Corporate"}
                  />
                  <label htmlFor="ingredient2" className="ml-3">
                    <div className="flex flex-column justify-content-start">
                      <p className="appointment-para">Corporate</p>
                      <p className="appointment-radio-para">
                        A legal entity that owns shares in the company.
                      </p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </>
        )}

        {shareholderType && (
          <ShareholderInformationForm
            setBtnToggle={setBtnToggle}
            formDetails={formDetails}
            setFormDetails={setFormDetails}
            regData={regData}
            setRegData={setRegData}
            isEditing={isEditing}
            shareholderType={shareholderType}
            statusOptions={statusOptions}
            legalStructureOptions={legalStructureOptions}
            resolveValue={resolveValue}
          />
        )}
      </div>
    </>
  );
};

export default ShareholderInformationWrapper;
